<div class="dont-forget-to-smile-container d-flex gap-2">
    <div class="dont-forget-to-smile-container-text-container vertical-align-middle-container float-left">
        <span [translate]="'dont_forget_to_smile.text'" class="vertical-align-middle"></span>
    </div>
    <div class="icon-smile float-left"></div>
</div>
